module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-use-x-prefix-for-components-31.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/why-use-x-prefix-for-components.md
// module id = 600
// module chunks = 186